















































import {
  computed,
  defineComponent,
  PropType,
  ref,
  useContext,
  useRoute,
} from '@nuxtjs/composition-api'
import Popup from '@/packages/basis/components/Popup.vue'
import Teleport from '@/components/Teleport'
import { buttonsAction } from '@/composition/buttons'
import { ButtonAction } from '@/contracts/ButtonHeroAction'
import { useNuxtLink } from '@/composition/nuxtLink'

export default defineComponent({
  name: 'BlockButtonsItem',
  components: { Popup, Teleport },
  props: {
    buttonItem: {
      type: Object as PropType<ButtonAction>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const route = useRoute()
    const { clickHandler } = buttonsAction()
    const modalOpen = ref(false)
    const ctx = useContext()
    const YM_ID = ctx.$config.YM_ID
    const sizes = computed(() => [24, 24])

    const buttonIcon = props.buttonItem.icon && props.buttonItem.icon[0]?.url

    const getStyles = (button: ButtonAction) => {
      if (button.color) return null
      return {
        '--btn-background': button.background,
        '--btn-background-hover': button.backgroundHover,
        '--btn-border-color': button.borderColor,
        '--btn-text-color': button.labelColor,
        '--btn-text-hover-color': button.labelHoverColor,
        '--btn-border-radius': button.borderRadius,
      }
    }

    const getPopupStyles = (button: ButtonAction) => {
      if (button.type !== 'openModal') return null
      return {
        '--popup-background': button.modalBackground || 'white',
        '--popup-border': button.modalBorder || '1px solid white',
        '--popup-radius': button.modalRadius || '8px',
      }
    }

    const getClasses = (button: ButtonAction) => {
      return {
        'arrow-left': button.arrow,
        'action-item__no-padding': !button.padding && !button.color,
        'action-item__custom-styles':
          button.labelHoverColor ||
          button.labelColor ||
          button.background ||
          button.backgroundHover,
        'action-item__border': button.borderColor,
        'btn--basic':
          (button.color === 'Красная' && button.type !== 'switchLink') ||
          (button.type === 'switchLink' && route.value.fullPath === button.url),
        'btn--second':
          (button.color === 'Белая' && button.type !== 'switchLink') ||
          (button.type === 'switchLink' && route.value.fullPath !== button.url),
        'btn--with-icon': !!buttonIcon,
        'btn--transparent':
          (button.color === 'Прозрачная' && button.type !== 'switchLink') ||
          (button.type === 'switchLink' && route.value.fullPath === button.url),
        'btn--white-support':
          (button.color === 'Поддержка Белая' &&
            button.type !== 'switchLink') ||
          (button.type === 'switchLink' && route.value.fullPath !== button.url),
      }
    }

    const withOpenInNewTab = (
      linkProps: { is: string; href: string } | { to: string }
    ) => {
      return props.buttonItem.openInNewTab
        ? { ...linkProps, target: '_blank', rel: 'nofollow' }
        : linkProps
    }
    const componentProps = (item) => {
      const { ymEvent } = props.buttonItem
      const execYmEventStr =
        ymEvent &&
        `ym(${ymEvent.ymId || YM_ID}, '${ymEvent.ymMethod}', '${
          ymEvent.ymTarget
        }'); return true;`

      const { isNuxtLink } = useNuxtLink(item.url)

      if (!item.url) {
        return {
          type: 'button',
          onmousedown: execYmEventStr,
        }
      }

      if (!isNuxtLink.value) {
        return withOpenInNewTab({
          is: 'a',
          href: item.url,
          onmousedown: execYmEventStr,
        })
      }

      if ((item.type === 'link' || item.type === 'switchLink') && item.url) {
        return withOpenInNewTab({
          to: item.url,
          onmousedown: execYmEventStr,
        })
      }

      return {
        type: 'button',
        onmousedown: execYmEventStr,
      }
    }

    const onClick = (button: ButtonAction) => {
      if (button.type === 'openModal') {
        modalOpen.value = true
      }
      clickHandler(
        button.type,
        button.eventAction,
        button.eventCategory,
        button.jsCode
      )
      emit('button-click', button)
    }

    const onClosePopup = () => {
      modalOpen.value = false
    }

    return {
      buttonIcon,
      modalOpen,
      componentProps,
      getPopupStyles,
      getStyles,
      onClosePopup,
      onClick,
      getClasses,
      sizes,
    }
  },
})
